import { ReactNode } from "react";

export enum TextVariant {
  tiny, //14px
  small, //16px
  normal, //18px
  large, //20px
  xlarge, //24px
  xxlarge, //30px
  xxxlarge, //32px
}

export function getTextSize(variant?: TextVariant): string {
  switch (variant) {
    case TextVariant.tiny:
      return "text-sm"; // ~14px
    case TextVariant.small:
      return "text-base"; // ~16px
    case TextVariant.normal:
      return "text-lg"; // ~18px
    case TextVariant.large:
      return "text-xl"; // ~20px
    case TextVariant.xlarge:
      return "text-2xl"; // ~24px
    case TextVariant.xxlarge:
      return "text-3xl"; // ~30px
    case TextVariant.xxxlarge:
      return "text-[2rem] leading-9.5"; //32px
    default:
      return "text-lg";
  }
}

interface textProps {
  children: ReactNode;
  className?: string;
  variant?: TextVariant;
  bold?: boolean;
  ariaLabel?: string;
}
export default function Text({ children, className, variant, bold, ariaLabel }: textProps) {
  const textClassName = `font-sans ${bold ? "font-bold " : "font-normal"} ${getTextSize(variant)} ${
    className ?? ""
  } `;
  return (
    <p className={textClassName} aria-label={ariaLabel}>
      {children}
    </p>
  );
}

interface headerProps {
  children: ReactNode;
  className?: string;
  variant?: TextVariant;
  headerLvl: number;
  serif?: boolean;
}

export function Header({ children, className, variant, headerLvl, serif }: headerProps) {
  const Tag = `h${Math.min(Math.max(headerLvl, 1), 6)}` as keyof JSX.IntrinsicElements;
  const headerClassName = `${serif ? "font-serif" : "font-sans"} font-bold ${getTextSize(
    variant ?? TextVariant.large,
  )} ${className ?? ""}`;
  return <Tag className={headerClassName}>{children}</Tag>;
}
